export default __webpack_public_path__ + "static/media/support-notes-logo-cointelegraph.8faa01fd.svg";